import { SubCard } from './chunk-BVFKJJIU.js';
import { ProtocolValue, decodedOrRaw, legField } from './chunk-BL57CTJZ.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function ExecutionPlan({ items, label, renderItem, depth = 0 }) {
  if (depth >= 8) return /* @__PURE__ */ jsx(ProtocolValue, { value: items });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    depth === 0 && /* @__PURE__ */ jsx("p", { className: "mt-3 text-xs text-muted-foreground", children: "Requested execution plan" }),
    /* @__PURE__ */ jsx("ol", { className: "mt-3 flex min-w-0 flex-col gap-2", "aria-label": "Requested execution plan", children: items.map((item, i) => {
      const commands = decodedOrRaw(legField(item, "decoded_commands"));
      const actions = decodedOrRaw(legField(item, "decoded_actions"));
      const children = Array.isArray(commands) ? commands : Array.isArray(actions) ? actions : [];
      const allowRevert = decodedOrRaw(legField(item, "allow_revert"));
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        SubCard,
        {
          caption: `${i + 1}. ${label(item)}`,
          meta: allowRevert === true ? /* @__PURE__ */ jsx("span", { className: "text-xs", children: "Failure allowed" }) : void 0,
          children: children.length > 0 ? /* @__PURE__ */ jsx(ExecutionPlan, { items: children, label, renderItem, depth: depth + 1 }) : renderItem(item)
        }
      ) }, i);
    }) })
  ] });
}

export { ExecutionPlan };
//# sourceMappingURL=chunk-Q3BYN2FB.js.map
//# sourceMappingURL=chunk-Q3BYN2FB.js.map